import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';

const ModalEditarPago = ({ show, onHide, pagoData, onSuccess }) => {
    const [metodo, setMetodo] = useState('EFECTIVO');
    const [referencia, setReferencia] = useState('');
    const [cuentaBancariaId, setCuentaBancariaId] = useState('');
    const [clienteNombre, setClienteNombre] = useState('');
    const [clienteDocumento, setClienteDocumento] = useState('');
    const [cuentas, setCuentas] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            fetchCuentas();
        }
        if (pagoData) {
            setMetodo(pagoData.metodo || 'EFECTIVO');
            setReferencia(pagoData.referencia || '');
            setCuentaBancariaId(pagoData.cuenta_bancaria_id || '');
            setClienteNombre(pagoData.cliente_nombre || '');
            setClienteDocumento(pagoData.cliente_documento || '');
        }
    }, [pagoData, show]);

    const fetchCuentas = async () => {
        try {
            const response = await axios.get('/api/caja/cuentas');
            setCuentas(response.data);
        } catch (error) {
            console.error('Error fetching bank accounts:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation for Bank Account
        if (['TRANSFERENCIA', 'DEPOSITO'].includes(metodo) && !cuentaBancariaId) {
            return Swal.fire('Atención', 'Debe seleccionar una cuenta bancaria para este método de pago', 'warning');
        }

        setLoading(true);

        try {
            await axios.patch(`/api/comprobantes/${pagoData.comprobante_id}/pago`, {
                metodo,
                referencia,
                cuenta_bancaria_id: ['TRANSFERENCIA', 'DEPOSITO'].includes(metodo) ? cuentaBancariaId : null,
                isChica: pagoData.isChica,
                cliente_nombre: clienteNombre,
                cliente_documento: clienteDocumento
            });

            Swal.fire({
                icon: 'success',
                title: '¡Actualizado!',
                text: 'La información se actualizó correctamente.',
                timer: 2000,
                showConfirmButton: false
            });

            if (onSuccess) onSuccess();
            onHide();
        } catch (error) {
            console.error('Error updating payment:', error);
            Swal.fire('Error', error.response?.data?.error || 'No se pudo actualizar la información', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-pencil me-2"></i>
                    Editar Información de Pago
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Método de Pago</Form.Label>
                        <Form.Select
                            value={metodo}
                            onChange={(e) => setMetodo(e.target.value)}
                            required
                        >
                            <option value="EFECTIVO">EFECTIVO</option>
                            <option value="YAPE">YAPE</option>
                            <option value="PLIN">PLIN</option>
                            <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                            <option value="DEPOSITO">DEPOSITO</option>
                            <option value="TARJETA">TARJETA</option>
                        </Form.Select>
                    </Form.Group>

                    {['TRANSFERENCIA', 'DEPOSITO'].includes(metodo) && (
                        <Form.Group className="mb-3 animate__animated animate__fadeIn">
                            <Form.Label className="fw-bold text-primary">Cuenta Bancaria Destino</Form.Label>
                            <Form.Select
                                value={cuentaBancariaId}
                                onChange={(e) => setCuentaBancariaId(e.target.value)}
                                required
                            >
                                <option value="">-- Seleccione Cuenta --</option>
                                {cuentas.map(c => (
                                    <option key={c.id} value={c.id}>
                                        {c.banco} - {c.numero_cuenta} ({c.moneda})
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    )}

                    <hr />
                    <h6 className="mb-3 text-secondary italic">Datos del Cliente (Opcional corregir)</h6>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Nombre del Cliente / Razón Social</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Nombre completo"
                            value={clienteNombre}
                            onChange={(e) => setClienteNombre(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Documento (DNI/RUC)</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Número de documento"
                            value={clienteDocumento}
                            onChange={(e) => setClienteDocumento(e.target.value)}
                        />
                    </Form.Group>

                    <hr />

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Referencia / Código Operación</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ej: 123456"
                            value={referencia}
                            onChange={(e) => setReferencia(e.target.value)}
                        />
                        <Form.Text className="text-muted">
                            Deje en blanco si es efectivo y no tiene referencia.
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? 'Guardando...' : 'Guardar Cambios'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalEditarPago;
